import { Component } from '@angular/core';

@Component({
  selector: 'baoying-app-root',
  templateUrl: './baoying-app.component.html',
  standalone: false,
})
export class BaoyingAppComponent {
  title = 'baoying';
}
